<div class="option-meta">
    <div class="row">
        @if (model()?.type?.data?.options) {
        <ng-container [formArray]="formArray">
            @for (option of model()?.type?.data?.options; track option[metaOption.value.id]; let i = $index) {
            <app-option [formGroup]="$any($safeNavigationMigration(formArray?.at(i)))" [model]="option" [meta]="metaOption" (delete)="onDelete($event)"></app-option>
            }
        </ng-container>
        }
        <button [disabled]="!model().meta.formGroup.valid" type="button" class="button" (click)="onAddField()">
            <mat-icon class="small-icon">add_box</mat-icon>
        </button>
    </div>
</div>
